import {observer} from 'mobx-react-lite'
import React, {useEffect} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Button} from '@components/common/button/button'
import {useForceUpdate} from '@containers/hooks'
import {useFileViewerStore} from '../file-viewer-store'
import {ContentTypeIcon} from '../icons/type/content-type-Icon'
import {downloadFile} from '../utils/download'

const TwWrapper = tw.div`
  flex
  flex-col
  items-center
  justify-center
  h-full
  gap-24
`

const TwContent = tw.div`
  flex
  flex-col
  items-center
  gap-16
`

export const OtherView = observer(() => {
  const [state, store] = useFileViewerStore()

  const upd = useForceUpdate()
  useEffect(() => {
    upd()
  }, [state.currentFileIndex])

  const onClick = () => {
    downloadFile(state.currentFile?.url, store.name)
  }
  return (
    <TwWrapper>
      <TwContent>
        <div style={{transform: 'scale(2.6666)'}}>
          <ContentTypeIcon contentType={state.currentFile?.contentType} />
        </div>
        <div className="text-15 text-main-old-dark">{store.name}</div>
      </TwContent>
      <TwContent>
        <div className="text-14 text-main-old-dark">
          {Lang.msg.fileViewer.fileCannotBeViewed}
        </div>
        <Button onClick={onClick}>{Lang.msg.fileViewer.downloadFile}</Button>
      </TwContent>
    </TwWrapper>
  )
})
